import { Button, PhoneInput } from '@calizahq/react-components-v2'
import { LeadMutations } from '@sales-app/graphql/mutations/lead.mutations'
import { BookablePerson } from '@sales-app/types/BookablePerson'
import { Form, Formik } from 'formik'
import { FC, useState } from 'react'

import { Input } from '@/components'
import { useGraphqlMutation } from '@/hooks/useGraphql'

import { formSchema, FormValuesType } from './EditLead.util'

type Props = {
  lead: BookablePerson
  refetchOnSuccess: () => void
  toggle: () => void
}

export const EditLeadForm: FC<Props> = ({ toggle, refetchOnSuccess, lead }) => {
  const [error, setError] = useState<string>()

  const { mutate, isPending: isMutationLoading } = useGraphqlMutation(LeadMutations.updateLead(), {
    onSuccess: () => {
      refetchOnSuccess && refetchOnSuccess()
      toggle()
    },
    onError: (res: { response: { errors: { message: string }[] } }) => {
      const { response } = res
      if (response.errors && response.errors.length) {
        setError(response.errors[0].message)
      }
    },
  })

  const handleSubmit = (values: FormValuesType) => {
    const { phone, email } = values
    if (!email && !phone) {
      setError('Phone or Email, is required for lead creation')
      return
    }

    mutate({
      lead: {
        ...values,
        id: lead.bookablePersonId,
        phone: phone || null,
        email: email || null,
      },
    })
  }

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={{
          phone: lead.phone || '',
          firstName: lead.firstName || '',
          lastName: lead.lastName || '',
          email: lead.email || '',
        }}
        onSubmit={handleSubmit}
        validationSchema={formSchema}
      >
        {() => {
          return (
            <Form className="flex w-full flex-col flex-wrap px-6 md:max-w-120">
              <p className="leading-nonemt-4 mb-4 font-bold text-header-md">Edit Lead</p>
              <div className="flex w-full flex-col md:grid md:grid-cols-2 md:gap-4">
                <Input
                  className="mb-4 mr-4 w-full"
                  id="firstName"
                  label="First Name"
                  name="firstName"
                  placeholder="First Name"
                  showSuccess={false}
                />
                <Input
                  className="mb-4 w-full"
                  id="lastName"
                  label="Last Name"
                  name="lastName"
                  placeholder="Last Name"
                  showSuccess={false}
                />
              </div>

              <Input
                className="mb-4 w-full"
                id="email"
                label="Email"
                name="email"
                placeholder="Email"
                showSuccess={false}
                type="email"
              />
              <PhoneInput
                className="mb-4 w-full"
                defaultCountry="US"
                id="phone"
                international={true}
                label="Phone"
                name="phone"
                placeholder="Phone"
              />

              {error && <p className=" mb-4 text-p-sm text-text-semantic-error">{error}</p>}
              <div className="mt-4 flex flex-col-reverse justify-between md:flex-row">
                <Button
                  className="w-full bg-action-secondary md:flex md:w-auto"
                  onClick={toggle}
                  size="small"
                  variant="secondary"
                >
                  Close
                </Button>
                <Button
                  className="mb-2 w-full bg-text-semantic-success md:mb-0 md:w-auto"
                  disabled={isMutationLoading}
                  isLoading={isMutationLoading}
                  size="small"
                  type="submit"
                >
                  Update lead
                </Button>
              </div>
            </Form>
          )
        }}
      </Formik>
    </>
  )
}
